import Fetch from "../../../../../pages/open-data/Fetch";
import Datasets from "../../../../../pages/open-data/DataSets";
import * as React from 'react';
export default {
  Fetch,
  Datasets,
  React
};